export const sentences = {
  venom: {
    low:
      "I feel something in you, you might be a good fit for the venom symbiote..",
    medium:
      "The venom symbiote seems to be a good fit. Can you feel the power ?",
    ultra: "WE are Venom ! You are a perfect host for the venom symbiote.."
  },
  carnage: {
    low: "You are mad but not enough for the Carnage symbiote..",
    medium:
      "You are a dangerous sociopath and homicidal maniac and seems to be a good fit for the carnage symbiote..",
    ultra:
      "I am Carnage ! You are a mentally unstable serial killer and a perfect host for the bloodthirsty carnage symbiote.."
  }
};
